module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_rogaland_pos.a7bb296d.svg";